// extracted by mini-css-extract-plugin
export default {"items":"School_items__5vNiZ"};